import React, { useEffect } from 'react';
import { htmlDecode } from '../helpers/functions';

import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Separator = ({ ...props }) => (
  <span {...props} className="mx-6 w-2 h-2 bg-primary"></span>
);

export function PostExcerpt({
  category,
  url,
  title,
  excerpt,
  thumbnail,
  date,
  read,
}) {
  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 1 });

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  const variants = {
    visible: { scale: 1 },
    hidden: { scale: 0 },
  };
  return (
    <motion.article
      ref={ref}
      animate={controls}
      variants={variants}
      initial="hidden"
      transition={{
        duration: 0.5,
        ease: 'easeOut',
      }}
      className="py-16 border-b border-gray-light last:border-primary"
    >
      <div className="container">
        <a
          href={url}
          className="transition duration-500 group text-secondary no-underline"
        >
          {excerpt && (
            <div className="flex flex-wrap md:flex-nowrap my-8">
              {thumbnail && (
                <div className="w-full md:w-1/4 px-4 md:px-0 mb-4 md:mb-0">
                  <img src={thumbnail} alt={title} className="block mx-auto" />
                </div>
              )}
              <div className="w-full md:w-3/4 pl-8">
                {category && (
                  <div
                    className="uppercase text-sm font-bold"
                    dangerouslySetInnerHTML={{
                      __html: htmlDecode(category.name),
                    }}
                  />
                )}
                {title && (
                  <h3
                    className="font-primary text-24 mb-4"
                    dangerouslySetInnerHTML={{ __html: htmlDecode(title) }}
                  />
                )}
                <footer className="flex items-center text-sm mb-4">
                  <span>{date}</span>
                  <Separator />
                  <span>
                    Read Time: {` `}
                    {read}
                  </span>
                </footer>
                <div
                  className=""
                  dangerouslySetInnerHTML={{
                    __html: htmlDecode(excerpt),
                  }}
                />
                <span className="inline-block py-2 px-8 mt-8 bg-primary font-bold text-white uppercase text-sm">
                  Read More
                </span>
              </div>
            </div>
          )}
        </a>
      </div>
    </motion.article>
  );
}
